import React, { FC, useContext } from "react";
import { ApexOptions } from "apexcharts";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import 'moment/locale/pt-br';
import { useIntl } from "react-intl";
import { LANG_COMMON_PAIRINGS } from "../../../lang";
import { AuthContext } from "../../../providers/AuthContextProvider";
import { translateBusinessTypeTerms } from "../../../components/TranslateTerms";

interface Props {
    stats: any
}

const TreatmentTypeChart: FC<Props> = ({ stats }) => {
    const intl = useIntl();
    const authContext = useContext(AuthContext);
    const user = authContext.user;

    var height = 300;
    var labelColor = "#A1A5B7";
    var borderColor = "#E4E6EF";
    var baseColor = "#25325b";
    var lightColor = "#25325b";

    let pairingColor = "#2E93fA";
    let receiversColor = "#66DA26";
    let donorsColor = "#546E7A";

    var optionsApex: ApexOptions = {
        chart: {
            fontFamily: 'inherit',
            type: 'line',
            height: height,
            toolbar: {
                show: false
            }
        },
        plotOptions: {

        },
        legend: {
            show: false
        },
        dataLabels: {
            enabled: true
        },
        fill: {
            type: "solid"
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 3,
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0
                }
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0
                }
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0
                }
            }
        },
        tooltip: {
            style: {
                fontSize: '12px'
            },
            y: {
                formatter: function (val) {
                    return val.toString()
                }
            }
        },
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
    };

    return (
        <>
            <ReactApexChart
                options={optionsApex}
                type="pie"
                series={stats.tratamentos.map((item: any) => item.total)}
                labels={stats.tratamentos.map((item: any) => item.type)}
            />
        </>
    );
}

export default TreatmentTypeChart;